import { rdrRequests } from "../httpRequest";

const drawApiRequest = {
    getDrawApplicationData: (placeId: number, facilityId: number, startDate: string) => rdrRequests.get(`search/application/${placeId}/${facilityId}/startdate/${startDate}`),
    getPlaceList: () => rdrRequests.get(`fd/places`),
    getCustomerDrawApplicationData: (requestData: any) => rdrRequests.post(`search/applicationsearch`, requestData)
}

export default drawApiRequest;